module.exports = __webpack_public_path__ + "assets/RetinaNarr-Book.a5a4915f015568fdd4824498b164ffb3.woff";